import {NextSeo} from "next-seo";
import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";
import Carousel, { ResponsiveType } from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Banner from "src/components/widgets/bannerNew/Banner";
import sanity from "src/sanity/sanity";
import Classes from "src/sanity/types/Classes";
import { Colours, styled } from "src/styles";
import Section from "../../../components/widgets/section/Section";

type ClassProps = {
    classes: Classes[];
};

export default function Class(props: ClassProps) {
    const { classes } = props;

    const router = useRouter();
    const { slug } = router.query;

    const clazz = (classes || []).find((c) => c.slug.current === slug);

    if (clazz == null) {
        return null;
    }

    const sanityImage = clazz.image != null ? sanity.urlFor(clazz.image) : undefined;

    const responsive: ResponsiveType = {
        desktop: {
            breakpoint: { max: 4000, min: 1800 },
            items: 3,
        },
        tablet: {
            breakpoint: { max: 1600, min: 800 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 800, min: 0 },
            items: 1,
        },
    };

    return (
        <>
            <NextSeo
                title={clazz.name}
                openGraph={{
                    title: clazz.name,
                    description: clazz.description,
                    images: [
                        {
                            url: sanityImage?.url(),
                        },
                    ],
                }}
            />
            <Banner image={sanityImage?.url()}
                    title={clazz.name}
                    body={(
                        <>
                            <strong>{clazz.ageRange}</strong>
                            <p dangerouslySetInnerHTML={{ __html: `${clazz.description ?? ""}`.replace(/\n/g, "<br/>") }} />
                        </>
                    )} />

            {(clazz.classes?.length ?? 0) !== 0 && (
                <Section center backgroundColour={Colours.BACKGROUND}>
                    <h2>Levels</h2>
                    <Slider responsive={responsive}
                            ssr
                            deviceType={"desktop"}
                            transitionDuration={750}>
                        {clazz.classes.map(({ _key, name, ageRange, description }) => (
                            <ClassItem key={_key}>
                                <ClassItemInner>
                                    <ClassName>{name}</ClassName>
                                    <ClassAgeRange>{ageRange}</ClassAgeRange>
                                    <ClassDescription
                                        dangerouslySetInnerHTML={{ __html: `${description ?? ""}`.replace(/\n/g, "<br/>") }} />
                                </ClassItemInner>
                            </ClassItem>
                        ))}
                    </Slider>
                </Section>
            )}
            {/*<Section center>*/}
            {/*    <h2>Gallery</h2>*/}
            {/*    <Grid>*/}
            {/*        {clazz.images?.map((image, index) => {*/}

            {/*            const img = sanity.urlFor(image);*/}

            {/*            return (*/}
            {/*                <div key={`${index}`} style={{ width: "25%", aspectRatio: "1", position: "relative" }}>*/}
            {/*                    <Image src={img.url()} layout={"fill"} quality={100} objectPosition={"center"}*/}
            {/*                           objectFit={"cover"} />*/}
            {/*                </div>*/}
            {/*            );*/}
            {/*        })}*/}
            {/*    </Grid>*/}
            {/*</Section>*/}
        </>
    );
}

export async function getStaticProps(): Promise<any> {
    const classes = await sanity.getClasses();
    return {
        props: {
            classes,
        },
        revalidate: 60,
    };
}

export async function getStaticPaths() {
    const classes = await sanity.getClasses();
    return {
        paths: classes.map(({ slug: { current } }) => `/classes/${current}`),
        fallback: true,
    };
}

const SliderContainer = styled.div`
    width: 100%;
    min-height: 250px;
`;

const Slider = styled(Carousel)`
    width: 100%;


    .react-multiple-carousel__arrow--left {
        top: 0;
    }

    .react-multiple-carousel__arrow--right {
        top: 0;
    }
`;

const ClassItem = styled.div`
    //max-height: 500px;
    //background-color: orange;
    padding: 18px;
    display: flex;
`;
const ClassItemInner = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 36px;
    //align-items: center;
    //justify-content: center;
    background-color: white;
`;

const ClassName = styled.h3``;
const ClassAgeRange = styled.strong``;
const ClassDescription = styled.p`
    text-overflow: ellipsis;
`;

const Grid = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
`;
